import { createSelector } from 'reselect';
import { Gruser } from '../../types/papi';
import { AppState } from '../../types/store';
import { getCurrentGruserSlice } from './grusers';

/* export const getLayout = (
  state: AppState,
  gruser: Gruser | undefined
): LayoutSlice | undefined => getCurrentGruserSlice(state, gruser)?.layout;
*/

export const getLayout = createSelector(
  state => state,
  (_, gruser) => gruser,
  (state, gruser) => getCurrentGruserSlice(state, gruser)?.layout
);

export const getVersion = (
  state: AppState,
  gruser: Gruser | undefined
): number | undefined => getLayout(state, gruser)?.version;

export const getZones = (state: AppState, gruser: Gruser | undefined) =>
  getLayout(state, gruser)?.zones || {};
